const OFFSET_X = 8;
const DELTA_X = 32;
const X_DISTANCE_APART = 72;

// TODO: Use this when we move the golden egg image to the left side of the hero
export const CARD_VARIANTS_DESKTOP_NEW_V2 = {
  initial: {
    y: 0,
    x: -DELTA_X + OFFSET_X,
    z: 0,
  },
  default: {
    y: [0, 0, 0],
    x: [DELTA_X + OFFSET_X, X_DISTANCE_APART + OFFSET_X, -DELTA_X + OFFSET_X],
    z: [-48, 0, 0],
  },
  toggled: {
    y: [0, 0, 0],
    x: [-DELTA_X + OFFSET_X, -X_DISTANCE_APART + OFFSET_X, DELTA_X + OFFSET_X],
    z: [0, 0, -48],
  },
  initialEgg: {
    y: 0,
    x: DELTA_X + OFFSET_X,
    z: -156,
  },
  defaultEgg: {
    y: [0, 0, 0],
    x: [-DELTA_X + OFFSET_X, -X_DISTANCE_APART + OFFSET_X, DELTA_X + OFFSET_X],
    z: [0, 0, -156],
  },
  toggledEgg: {
    y: [0, 0, 0],
    x: [DELTA_X + OFFSET_X, X_DISTANCE_APART + OFFSET_X, -DELTA_X + OFFSET_X],
    z: [-156, 0, 0],
  },
};

// Use this with new hero component
const OFFSET_X_NEW = 32;
const DELTA_X_NEW = 40;
const X_DISTANCE_APART_NEW = 156;

export const CARD_VARIANTS_DESKTOP_NEW = {
  initial: {
    y: 0,
    x: DELTA_X_NEW - OFFSET_X_NEW,
    z: 0,
  },
  default: {
    y: [0, 0, 0],
    x: [
      -DELTA_X_NEW - OFFSET_X_NEW,
      -X_DISTANCE_APART_NEW - OFFSET_X_NEW,
      DELTA_X_NEW - OFFSET_X_NEW,
    ],
    z: [-48, 0, 0],
  },
  toggled: {
    y: [0, 0, 0],
    x: [
      DELTA_X_NEW - OFFSET_X_NEW,
      X_DISTANCE_APART_NEW - OFFSET_X_NEW,
      -DELTA_X_NEW - OFFSET_X_NEW,
    ],
    z: [0, 0, -48],
  },
  initialEgg: {
    y: 0,
    x: -40 - OFFSET_X_NEW,
    z: -164,
  },
  defaultEgg: {
    y: [0, 0, 0],
    x: [
      DELTA_X_NEW - OFFSET_X_NEW,
      X_DISTANCE_APART_NEW - OFFSET_X_NEW,
      -DELTA_X_NEW - OFFSET_X_NEW,
    ],
    z: [0, 0, -156],
  },
  toggledEgg: {
    y: [0, 0, 0],
    x: [
      -DELTA_X_NEW - OFFSET_X_NEW,
      -X_DISTANCE_APART_NEW - OFFSET_X_NEW,
      DELTA_X_NEW - OFFSET_X_NEW,
    ],
    z: [-156, 0, 0],
  },
};

export const CARD_VARIANTS_MOBILE_NEW = {
  initial: {
    x: 0,
    y: 0,
    z: 0,
  },
  default: {
    x: [0, 0, 0],
    y: [20, -256, 0],
    z: [-64, 0, 0],
  },
  toggled: {
    x: [0, 0, 0],
    y: [10, 30, 48],
    z: [0, 0, -270],
  },
  initialEgg: {
    x: 0,
    y: 48,
    z: -270,
  },
  defaultEgg: {
    x: [0, 0, 0],
    y: [-20, 30, 48],
    z: [0, 0, -270],
  },
  toggledEgg: {
    x: [0, 0, 0],
    y: [48, -256, 0],
    z: [-270, 0, 0],
  },
};

// TODO: Remove when we merge hero unification changes to prod
export const CARD_VARIANTS_DESKTOP = {
  initial: {
    y: 0,
    x: 40,
    z: 0,
  },
  default: {
    y: [0, 0, 0],
    x: [-40, -156, 40],
    z: [-48, 0, 0],
  },
  toggled: {
    y: [0, 0, 0],
    x: [40, 156, -40],
    z: [0, 0, -48],
  },
  initialEgg: {
    y: 0,
    x: -40,
    z: -164,
  },
  defaultEgg: {
    y: [0, 0, 0],
    x: [40, 156, -40],
    z: [0, 0, -156],
  },
  toggledEgg: {
    y: [0, 0, 0],
    x: [-40, -156, 40],
    z: [-156, 0, 0],
  },
};

export const CARD_VARIANTS_MOBILE = {
  initial: {
    x: 0,
    y: -10,
    z: 0,
  },
  default: {
    x: [0, 0, 0],
    y: [16, -256, -16],
    z: [-64, 0, 0],
  },
  toggled: {
    x: [0, 0, 0],
    y: [-16, 30, 16],
    z: [0, 0, -92],
  },
  initialEgg: {
    x: 0,
    y: 24,
    z: -156,
  },
  defaultEgg: {
    x: [0, 0, 0],
    y: [-16, 30, 16],
    z: [0, 0, -156],
  },
  toggledEgg: {
    x: [0, 0, 0],
    y: [16, -256, -16],
    z: [-156, 0, 0],
  },
};
